import React from 'react';
import PropTypes from 'prop-types';
import * as types from '../../constants/actionTypes';
import Drawer from '../Common/Drawer/Drawer';
import Notification from '../Common/Notification';
import LoadingIndicator from '../Common/LoadingIndicator/LoadingIndicator';
import MultiSelectBox from '../Common/MultiSelectBox/MultiSelectBox';

export class LinkProjectBaselineDrawer extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            baselines: [],
            isLoading: false,
            selectedBaselines: '',
            isFormValid: true
        };
    }

    async componentDidMount() {
        await this.loadFilters();
    }

    async loadFilters() {
        try {
            this.setState({ isLoading: true });
            const request = {
                subscriptionId: this.props.subscriptionId,
                projectKey: this.props.projectKey
            };
            const result = await this.props.projectMgrDashboardActions.loadProjectBaselineFilters(request);
            if (result.type === types.LOAD_PROJECT_BASELINE_FILTERS_SUCCESS) {
                this.setState({ baselines: result.payload.baselines });
            } else if (result.type === types.LOAD_PROJECT_BASELINE_FILTERS_FAILURE) {
                Notification("error", "An Error Occurred", result.payload.message)
                this.props.onCancel();
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    async save() {
        try {
            this.setState({ isLoading: true });
            const request = {
                subscriptionId: this.props.subscriptionId,
                projectKey: this.props.projectKey,
                baselineIds: this.state.selectedBaselines.trim().split(',')
            };
            const result = await this.props.projectMgrDashboardActions.linkProjectBaseline(request)
            if (result.type === types.LINK_PROJECT_BASELINE_SUCCESS) {
                Notification("success", "Save Successful", "Baselines linked to project successfully")
                this.props.onComplete();
            } else if (result.type === types.LINK_PROJECT_BASELINE_FAILURE) {
                Notification("error", "An Error Occurred", result.payload.message)
                this.setState({ isLoading: false });
            }
        } catch (error) {
            Notification("error", "An Error Occurred", error);
            this.setState({ isLoading: false });
        }
    }

    saveClick = () => {
        if (!this.state.selectedBaselines || !this.state.selectedBaselines.trim().length) {
            this.setState({ isFormValid: false });
            return;
        }
        this.setState({ isFormValid: true });
        this.save();
    }

    cancelClick = () => {
        this.props.onCancel();
    }

    onDropdownChange = (csv) => {
        this.setState({ selectedBaselines: csv });
    }

    render() {
        return (
            <Drawer isWide={false} title="Baseline" onSaveClick={this.saveClick} onCancelClick={this.cancelClick}>
                <LoadingIndicator isLoading={this.state.isLoading}>
                    <div className="identifier-form">
                        <form noValidate className={this.state.isFormValid ? "" : "was-validated"} onSubmit={this.saveClick}>
                            <MultiSelectBox name="selectedBaselines" label="Baselines" idField="id" valueField="name"
                                options={this.state.baselines}
                                selectedValues={this.state.selectedBaselines}
                                onChange={this.onDropdownChange}
                                isMulti={true}
                            />
                        </form>
                    </div>
                </LoadingIndicator>
            </Drawer>
        );
    }
}

LinkProjectBaselineDrawer.propTypes = {
    subscriptionId: PropTypes.string.isRequired,
    projectKey: PropTypes.string.isRequired,
    projectMgrDashboardActions: PropTypes.object.isRequired,
    onComplete: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired
}

export default LinkProjectBaselineDrawer;

